/**
 * Main Layout Component
 *
 * Wrapper for all authenticated pages
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppHeader from './AppHeader';
import AppNav from './AppNav';
import AssistantWidget from '../Assistant/AssistantWidget';
import api from '../../services/api';
import './MainLayout.css';

const MainLayout = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await api.getCurrentUser();
        setUser(response.data.data.user);
      } catch (err) {
        console.error('Error fetching user:', err);

        // Development mode fallback: use mock user if API fails
        if (process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') {
          console.warn('Using development fallback user');
          setUser({
            id: 'dev-user-001',
            email: 'developer@guidewire.com',
            firstName: 'Development',
            lastName: 'User',
            role: 'admin',
            isActive: true,
            emailNotifications: true,
          });
        } else {
          setError(err.message);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) {
    return (
      <div className="main-layout__loading">
        <div className="main-layout__spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="main-layout__error">
        <p>Error loading user profile</p>
        <button onClick={() => window.location.reload()}>Retry</button>
      </div>
    );
  }

  return (
    <div className="main-layout">
      <AppHeader user={user} onRoleChange={(role) => setUser(u => ({ ...u, role }))} />
      <AppNav userRole={user?.role} />
      <main className="main-layout__content">
        <div className="main-layout__container">{children}</div>
      </main>
      <AssistantWidget />
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;
